import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { usePageSeo } from "@/hooks/usePageSeo";
import { Button } from "@/components/ui/button";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsroomLoginPage = () => {
  usePageSeo({
    canonicalPath: "/newsroom-login",
    description: "Content Watch HQ newsroom login for editors and office staff.",
    robots: "noindex,nofollow",
    title: "Newsroom Login | Content Watch HQ",
  });

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (window.localStorage.getItem("content_watch_token")) {
      navigate("/office-use");
    }
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await axios.post(`${API_BASE}/auth/login`, { email, password });
      window.localStorage.setItem("content_watch_token", response.data.token);
      navigate("/office-use");
    } catch {
      setError("Login failed. Please check the newsroom credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="page-shell mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8" data-testid="newsroom-login-page">
      <section className="border border-[rgba(10,15,26,0.12)] bg-white p-6 shadow-[0_20px_60px_rgba(15,23,42,0.04)] sm:p-8" data-testid="newsroom-login-panel">
        <p className="eyebrow text-red-600" data-testid="newsroom-login-overline">Office use</p>
        <h1 className="headline-lg mt-3" data-testid="newsroom-login-title">Newsroom Login</h1>
        <p className="mt-4 text-base leading-8 text-slate-700" data-testid="newsroom-login-copy">Log in to publish written stories, upload multiple photos, and add optional YouTube links directly into the website.</p>
        <p className="mt-3 text-sm leading-7 text-slate-600" data-testid="newsroom-login-helper-copy">Use your newsroom office credentials to continue.</p>
        <form className="mt-8 grid gap-4 sm:gap-5" data-testid="newsroom-login-form" onSubmit={handleSubmit}>
          <input className="border border-[rgba(10,15,26,0.12)] px-4 py-4 text-sm outline-none focus:border-slate-950" data-testid="newsroom-login-email-input" onChange={(event) => setEmail(event.target.value)} placeholder="Email" required type="email" value={email} />
          <input className="border border-[rgba(10,15,26,0.12)] px-4 py-4 text-sm outline-none focus:border-slate-950" data-testid="newsroom-login-password-input" onChange={(event) => setPassword(event.target.value)} placeholder="Password" required type="password" value={password} />
          {error ? <p className="text-sm text-red-600" data-testid="newsroom-login-error">{error}</p> : null}
          <Button className="rounded-none bg-[#D21404] px-5 py-6 text-xs font-bold uppercase tracking-[0.2em] text-white hover:bg-[#B31203]" data-testid="newsroom-login-submit-button" disabled={loading} type="submit">
            {loading ? "Logging in" : "Enter Newsroom"}
          </Button>
        </form>
      </section>
    </main>
  );
};